import { createNodesWithHOC } from '@udecode/plate-common';
import { withDraggable } from '@udecode/plate-dnd';

import { PlateDraggable } from './PlateDraggable';

export const withPlateDraggable = (
  Component,
  options,
) => {
  return withDraggable(PlateDraggable, Component, options);
};

export const withPlateDraggables = createNodesWithHOC(withPlateDraggable);